import { AxiosResponse } from 'axios'
import { apiNode } from './api'

import { GetInfoBoxResponseData } from './types/item.interfaces'

const URL = '2/objects'

export const ItemsService = {
	// dashboard items
	async getInfoBoxItems({
		showInbox,
		showNotes,
		showTodos,
	}: {
		showInbox?: boolean
		showNotes?: boolean
		showTodos?: boolean
	}) {
		// Build types parameter based on filter states
		// type 2 = inbox, type 3 = note, type 4 = todo
		const types: number[] = []
		showInbox && types.push(2)
		showNotes && types.push(3)
		showTodos && types.push(4)

		const params = new URLSearchParams()
		types.forEach((type) => params.append('types', type.toString()))

		const response: AxiosResponse<GetInfoBoxResponseData> =
			await apiNode.get<GetInfoBoxResponseData>(
				`${URL}/recent-objects?${params.toString()}`
			)
		return response.data
	},
}
